import AppCourseRegistrationContainer from '@js/components/course/AppCourseRegistrationContainer.vue'

const courseComponents = [
  AppCourseRegistrationContainer,
]

export default courseComponents
